import type * as React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

/**
 * Four-pointed sparkle that marks assistant surfaces — the pane header, the
 * suggestion chips, and the nav entry point. Filled rather than stroked, which
 * is what keeps it legible at the 12px the chips render it at.
 */
export const SparkleIcon: React.FC<IProps> = ({ color = 'currentColor', size = 16, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.00581 0.00671885C6.20514 3.22305 8.77808 5.79584 11.9937 5.9942C12.0021 5.99533 12.0021 6.006 11.9937 6.0067C8.77847 6.20506 6.20509 8.7769 6.00581 11.9933C6.00496 12.0022 5.99464 12.0022 5.99421 11.9933C5.79494 8.77689 3.22156 6.20506 0.00635999 6.0067C-0.00214187 6.00563 -0.00209809 5.99491 0.00635999 5.9942C3.22152 5.79584 5.79489 3.22305 5.99421 0.00671885C5.99507 -0.00223962 6.00539 -0.00223962 6.00581 0.00671885Z"
      fill={color}
    />
  </svg>
);

export default SparkleIcon;
